import { filterProps } from '../utils';
import { FormatError } from 'intl-messageformat';
import { ReactIntlError } from '../error';
var DISPLAY_NAMES_OPTONS = ['localeMatcher', 'style', 'type', 'fallback'];
export function formatDisplayName(_ref, getDisplayNames, value) {
  var locale = _ref.locale,
      onError = _ref.onError;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var DisplayNames = Intl.DisplayNames;

  if (!DisplayNames) {
    onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", "MISSING_INTL_API"
    /* MISSING_INTL_API */
    ));
  }

  var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);

  try {
    return getDisplayNames(locale, filteredOptions).of(value);
  } catch (e) {
    onError(new ReactIntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting display name.', e));
  }
}